import { render, staticRenderFns } from "./stationAppointmentSetting.vue?vue&type=template&id=0f17630e&scoped=true"
import script from "./stationAppointmentSetting.vue?vue&type=script&lang=js"
export * from "./stationAppointmentSetting.vue?vue&type=script&lang=js"
import style0 from "./stationAppointmentSetting.vue?vue&type=style&index=0&id=0f17630e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.21_babel-core@6.26.3_cache-loader@4.1.0_webpack@4.47_l4fxjmgfph2izuapsepws7m6hy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f17630e",
  null
  
)

export default component.exports